import React, { useEffect, useState } from 'react';
import HomeProfileImage from '../../images/CoverPic.jpeg';

const HeroSection = () => {
     const [scrollY, setScrollY] = useState(0);


       useEffect(() => {
         const handleScroll = () => {
           requestAnimationFrame(() => {
             setScrollY(window.scrollY);
           });
         };
     
         window.addEventListener('scroll', handleScroll);
         return () => window.removeEventListener('scroll', handleScroll);
       }, []);

  return (
   <>
   <div className="w-full h-screen relative overflow-hidden" style={{ overscrollBehavior: 'none' }}>
   {/* Parallax Background */}
   <div
     className="absolute inset-0 w-full h-full bg-cover bg-center transition-transform duration-200 ease-out"
     style={{
       backgroundImage: `url(${HomeProfileImage})`,
       transform: `translateY(${scrollY * 0.3}px) scale(1.1)`,
       backgroundPosition: 'center',
       zIndex: 0,
     }}
     aria-hidden="true"
   ></div>

   {/* Name Only */}
   <div className="absolute bottom-10 left-0 mb-10 text-white z-10 px-4 md:px-8 xl:px-24">
     <h1 className="text-4xl md:text-6xl lg:text-[150px] drop-shadow-2xl">
       Slade Justin Ferrao
     </h1>
   </div>
 </div>
 </>
  );
};

export default HeroSection;